import classNames from "classnames";
import { Icon } from "PFComponents/icon";
import { Tooltip } from "PFComponents/tooltip";

import css from "../input_field_set.module.scss";

type LockedIconProps = {
  className?: string;
  lockedTip?: string;
  lockedTipPosition?: "top" | "bottom";
};

export const LockedIcon = ({ className, lockedTip, lockedTipPosition = "top" }: LockedIconProps) => (
  <Tooltip disabled={!lockedTip} placement={lockedTipPosition} content={<span>{lockedTip}</span>}>
    <div aria-label={lockedTip} className={classNames(css.icon, css.lockIcon, className)}>
      <Icon name="locked" size="sm" color="paletteBlue0" />
    </div>
  </Tooltip>
);
